<template>
    <a-select v-model="selectId" :defaultValue="defaultValue" style="width: 250px;" @change="changeStation">
        <a-select-option v-for="item in select" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
    </a-select>
</template>

<script>
    export default {
        name: "stationSelect",
        data(){
            return {
                groupId: 0,
                select: [],
                defaultValue: 0,
                selectId: 0
            }
        },
        mounted(){
          this.loadStation();
        },
        methods:{
            async loadStation(){
                let station = await this.$http.get(this.$baseURL.stationNoChildList({groupId: this.$Utils.getUserStorage().groupId}));
                this.select = [];
                let array = [];
                station.forEach((item, index) =>{
                    if(index === 0){
                        this.selectId = item.id;
                    }
                    array.push({
                        id: item.id,
                        name: item.name
                    })
                });
                this.select = array;
                this.changeStation();
            },
            changeStation(){
                this.$emit('changeStation', this.selectId);
            }
        }
    }
</script>

<style scoped>

</style>